import { Accordion, Text } from '@tallink/components-lib'
import { mediaQueries } from '@tallink/components-lib/src/constants/media'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useMedia } from 'react-use'

import { getMode } from '../../../selectors/selectors'
import s from './TermsAndConditions.module.scss'

export default function TermsAndConditions() {
  const smUp = useMedia(mediaQueries.smUp)
  const mode = useSelector(getMode)
  const { t } = useTranslation()

  const termsAndConditionsContent = (
    <Text className={s['terms-and-conditions']}>
      <ul className={s.list} dangerouslySetInnerHTML={{ __html: t(`termsAndConditions.text.${mode}`) }} />
    </Text>
  )

  return smUp ? (
    <>
      <div className={s.title}>{t(`srt.termsAndConditions.title.${mode}`)}</div>
      {termsAndConditionsContent}
    </>
  ) : (
    <Accordion titleContent={t(`srt.termsAndConditions.title.${mode}`)}>{termsAndConditionsContent}</Accordion>
  )
}
